class CustomQuiz extends HTMLElement {
  constructor() {
    super();

    console.log(
      "%cCUSTOM QUIZ FOR SHOPIFY STORES BY kevinschade.com",
      "font-size: 18px; font-weight: 600; color: #fff;background: #F11D64; padding: 10px 20px; border-radius: 5px; width: 100%"
    );

    this.id = this.dataset.quizId;
    this.graphqlId = this.dataset.graphqlId;
    this.handle = this.dataset.quizHandle;
    this.type = this.dataset.quizType;
    this.myshopify = this.dataset.myshopify;
    this.startQuestionHandle = this.dataset.startQuestionHandle;
    this.resultPageUrl = this.dataset.resultPageUrl;

    this.openQuizButtons = document.querySelectorAll(
      `.open-quiz-button[data-quiz-handle='${this.handle}']`
    );
    this.closeButton = this.querySelector("[data-close]");

    this.setupOpenClose();

    this.questionCards = this.querySelectorAll(".quiz-question-card");

    this.progressBar = this.querySelector(".quiz-overlay-head-progress");
    this.progressBarStepLabel = this.querySelector(
      ".quiz-overlay-head-progress-step span"
    );

    this.submitButton = this.querySelector(".quiz-submit-button");
    this.loadingOverlay = this.querySelector("custom-quiz-loading-overlay");

    this.submitUrl = "https://isocivdfxhvhqwesgwxv.supabase.co/functions/v1/cgs/submit-v2";

    window.addEventListener("hashchange", () => {
      this.toggleOnHash();
    });

    window.addEventListener("DOMContentLoaded", () => {
      this.toggleOnHash();
    });

    this.selectStartQuestion();
  }

  toggleOnHash() {
    if (window.location.hash.startsWith("#quiz")) {
      const quizHandle = window.location.hash.split("=")[1];
      if (quizHandle === this.handle) {
        this.selectStartQuestion();
        this.toggle();
        window.location.hash = "";
      }
    }
  }

  setupOpenClose() {
    this.openQuizButtons.forEach((openButton) => {
      openButton.addEventListener("click", () => {
        this.selectStartQuestion();
        this.toggle();
      });
    });

    this.closeButton.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    const currentState = this.dataset.open === "true";
    this.openWithoutHistory(!currentState);
    history.pushState(
      { openQuiz: this.dataset.open === "true" },
      "",
      window.location.pathname
    );
    console.log("PUSHING STATE");
  }

  openWithoutHistory(newState) {
    this.setAttribute("data-open", newState);
  }

  updateProgressBar() {
    let textProgressPercentage = (this.questionStackPointer + 1) / 5;
    textProgressPercentage = Math.round(textProgressPercentage * 100 - 5);
    textProgressPercentage =
      textProgressPercentage > 90 ? 90 : textProgressPercentage;
    let progressPercentage = textProgressPercentage;
    progressPercentage = progressPercentage < 12 ? 12 : progressPercentage;
    this.progressBar.setAttribute(
      "style",
      `--progress-percentage: ${progressPercentage}%`
    );

    this.progressBarStepLabel.textContent = textProgressPercentage + "%";
  }

  selectStartQuestion() {
    this.questionStack = [];
    this.questionStackPointer = 0;

    this.questionCards.forEach((card) => {
      card.resetSelection();
    });

    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);

    const newActive = Array.from(this.questionCards).find(
      (card) => card.dataset.quizQuestionHandle === this.startQuestionHandle
    );
    newActive.setAttribute("data-active", "transition");
    setTimeout(() => {
      newActive.setAttribute("data-active", true);
    }, 50);

    this.questionStack.push({
      questionHandle: this.startQuestionHandle,
      answers: null,
    });

    this.updateProgressBar();
    this.progressBar.setAttribute("data-show", true);
  }

  next() {
    const currentActiveQuestion = this.getCurrentActiveQuestion();
    const currentSelection = currentActiveQuestion.getCurrentSelection();

    const answers = [];

    // Creating an array of all answer data for the current question and adding it to the stack

    for (var selection of currentSelection) {
      const selectionMapping = JSON.parse(selection.dataset.mapping);
      answers.push(selectionMapping);
    }

    const currentActive = this.questionStack[this.questionStackPointer];
    currentActive.answers = answers;

    this.questionStackPointer = this.questionStackPointer + 1;

    // Going through all answers and adding next questions to the stack, reverse order

    for (var i = currentSelection.length - 1; i >= 0; i--) {
      var selection = currentSelection[i];
      const nextQuestionHandle = selection.dataset.nextQuestionHandle;
      const containsNextQuestion = this.questionStack.some(
        (question) => question.questionHandle === nextQuestionHandle
      );
      if (!containsNextQuestion) {
        this.questionStack.splice(this.questionStackPointer, 0, {
          questionHandle: nextQuestionHandle,
          answers: null,
        });
      }
    }

    // Submitting on end of quiz

    const nextQuestionHandle =
      this.questionStack[this.questionStackPointer].questionHandle;

    // Updating progress bar and hiding active question
    this.updateProgressBar();
    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);

    // Submitting if it's the last question
    if (
      nextQuestionHandle == null ||
      nextQuestionHandle == undefined ||
      nextQuestionHandle == ""
    ) {
      this.submit();
      return;
    }

    // Enabling next question card
    const newActive = Array.from(this.questionCards).find(
      (card) => card.dataset.quizQuestionHandle === nextQuestionHandle
    );
    newActive.setAttribute("data-active", "transition");
    setTimeout(() => {
      newActive.setAttribute("data-active", true);
    }, 50);
  }

  previous() {
    if (this.questionStackPointer === 0) {
      this.toggle();
      return;
    }
    this.selectStartQuestion();
  }

  async submit() {
    this.submitButton.setAttribute("disabled", true);
    this.submitButton.setAttribute("data-loading", true);
    this.loadingOverlay.toggle();

    const submitUrl = new URL(this.submitUrl);
    submitUrl.searchParams.set("shop", this.myshopify);
    submitUrl.searchParams.set("quizId", this.graphqlId);

    const postBody = [];

    for (var question of this.questionStack) {
      if (question.answers == null) {
        continue;
      }
      const answers = question.answers.filter(
        (answer) => answer.mappings.length != 0
      );

      postBody.push({
        questionHandle: question.questionHandle,
        answers,
      });
    }

    const submitResult = fetch(submitUrl, {
      method: "POST",
      body: JSON.stringify(postBody),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const minimumWait = new Promise((resolve, reject) => {
      setTimeout(resolve, 3000);
    });

    const [submitResultData] = await Promise.all([submitResult, minimumWait]);

    if (!submitResultData.ok) {
      alert(
        "Es ist ein Fehler aufgetreten. Bitte probiere es in ein paar Minuten erneut."
      );
      this.submitButton.removeAttribute("disabled");
      this.submitButton.setAttribute("data-loading", false);
      return;
    }

    const submitResultJson = await submitResultData.json();

    let mainAttribute = null;
    let mainAttributeUrl = null;
    postBody.forEach(question => {
      question.answers.forEach(answer => {
        answer.mappings.forEach(mapping => {
          if(mapping.attribute === "MAIN") {
            mainAttribute = mapping.values[0];
            mainAttributeUrl = mapping.values[1];
          }
        });

      })
    })

    let redirectBaseUrl = this.resultPageUrl;

    redirectBaseUrl = mainAttributeUrl;

    const searchParams = new URLSearchParams();
    searchParams.set("uuid", submitResultJson.uuid);
    const resultPageUrl = redirectBaseUrl + "?" + searchParams.toString();

    this.progressBar.setAttribute("data-show", false);
    this.loadingOverlay.toggle();

    setTimeout(() => {
      window.location.href = resultPageUrl;
    }, 501);
  }

  showLoadingOverlay() {
    this.getCurrentActiveQuestion()?.setAttribute("data-active", false);
    this.loadingOverlay.toggle();
  }

  getCurrentActiveQuestion() {
    const currentActive = Array.from(this.questionCards).find(
      (card) => card.dataset.active === "true"
    );
    return currentActive;
  }
}

class CustomQuizQuestionCard extends HTMLElement {
  constructor() {
    super();

    this.multichoice = this.dataset.multichoice === "true";
    this.nextButton = this.querySelector("button.full");
    this.previousButton = this.querySelector(".quiz-question-back-container");
    this.options = this.querySelectorAll(
      ".quiz-question-option:not(.quiz-question-option--dropdown)"
    );
    this.dropdownOptions = this.querySelectorAll(
      ".quiz-question-option--dropdown"
    );
    this.quiz = this.closest("custom-quiz");
    this.contentButton = this.querySelector(".quiz-question-content");
    this.quizContent = document.querySelector("custom-quiz-content");

    this.registerListeners();
  }

  registerListeners() {
    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        if (!this.multichoice) {
          this.resetSelection();
        }
        this.selectOption(option);
        this.validateForm();
        if (!this.multichoice) {
          this.quiz.next();
        }
      });
    });

    this.dropdownOptions.forEach((option) => {
      option.querySelector("select").addEventListener("change", () => {
        this.updateMappingAfterDropdownOption(option);
        this.validateForm();
      });
    });

    this.nextButton?.addEventListener("click", () => {
      this.quiz.next();
    });

    this.previousButton?.addEventListener("click", () => {
      this.quiz.previous();
    });

    this.contentButton?.addEventListener("click", () => {
      this.quizContent.toggle(this.dataset.quizQuestionIndex);
    });
  }

  updateMappingAfterDropdownOption(dropdownOption) {
    const mapping = JSON.parse(dropdownOption.dataset.mapping);
    const selectElValue = dropdownOption.querySelector("select").value;
    mapping["mappings"][0]["values"][0] = selectElValue;
    dropdownOption.dataset.mapping = JSON.stringify(mapping);
  }

  validateForm() {
    let isValid = this.getCurrentSelection().length > 0;

    if (isValid) {
      this.nextButton?.removeAttribute("disabled");
    } else {
      this.nextButton?.setAttribute("disabled", true);
    }

    return isValid;
  }

  getCurrentSelection() {
    const returnList = [];

    Array.from(this.options)
      .filter((option) => option.dataset.select === "true")
      .forEach((option) => {
        returnList.push(option);
      });

    Array.from(this.dropdownOptions)
      .filter((option) => option.querySelector("select").value !== "null")
      .forEach((option) => {
        returnList.push(option);
      });

    return returnList;
  }

  getCurrentTags() {
    return this.getCurrentSelection().map((option) => option.dataset.tag);
  }

  selectOption(optionEl) {
    const currentOptionState = optionEl.dataset.select === "true";
    optionEl.setAttribute("data-select", !currentOptionState);
  }

  resetSelection() {
    this.getCurrentSelection().forEach((option) => {
      option.setAttribute("data-select", false);
    });
  }
}

class CustomQuizContent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("quiz-question-content-popup") ||
        e.target.tagName === "path" ||
        e.target.tagName === "svg" ||
        e.target.hasAttribute("data-close")
      ) {
        this.closeAll();
      }
    });
  }

  closeAll() {
    this.querySelectorAll(
      ".quiz-question-content-popup-item[data-show='true']"
    ).forEach((item) => {
      this.toggle(item.dataset.quizQuestionIndex);
    });
  }

  toggle(questionIndex) {
    const item = this.querySelector(
      `.quiz-question-content-popup-item[data-quiz-question-index='${questionIndex}']`
    );
    const currentState = item.dataset.show === "true";

    item.setAttribute("data-show", "transition");
    const delay = currentState ? 300 : 50;
    setTimeout(() => {
      item.setAttribute("data-show", !currentState);
    }, delay);
  }
}

class CustomQuizLoadingOverlay extends HTMLElement {
  constructor() {
    super();

    this.lottiePlayer = this.querySelector("lottie-player");
    this.pageTransitionEl = this.querySelector(
      ".quiz-loading-overlay-animation-page-transition"
    );
    this.reviewWrapper = this.querySelector(
      ".quiz-loading-overlay-reviews-wrapper"
    );
  }

  toggle() {
    const newState = this.dataset.active !== "true";

    if (newState) {
      this.setAttribute("data-active", "transition");
      this.lottiePlayer.play();
      this.lottiePlayer.seek(0);

      setTimeout(() => {
        this.setAttribute("data-active", true);
        this.reviewWrapper.classList.add(
          "quiz-loading-overlay-reviews-wrapper-sliding"
        );

        setTimeout(() => {
          this.pageTransitionEl.classList.add("animate");
        }, 2500);
      }, 50);
    } else {
      this.setAttribute("data-active", "animate-reverse");
      this.reviewWrapper.classList.remove(
        "quiz-loading-overlay-reviews-wrapper-sliding"
      );
      this.lottiePlayer.stop();
      setTimeout(() => {
        this.setAttribute("data-active", false);
        this.pageTransitionEl.classList.remove("animate");
      }, 500);
    }
  }
}

customElements.define("custom-quiz-question-card", CustomQuizQuestionCard);
customElements.define("custom-quiz", CustomQuiz);
customElements.define("custom-quiz-content", CustomQuizContent);
customElements.define("custom-quiz-loading-overlay", CustomQuizLoadingOverlay);

window.onpopstate = function (event) {
  const quiz = document.querySelector("custom-quiz");

  if (!quiz) {
    return;
  }

  if (event.state && event.state.openQuiz) {
    quiz.openWithoutHistory(true);
  } else {
    quiz.openWithoutHistory(false);
  }
};
